export default __webpack_public_path__ + "static/media/2.53fc107b.jpg";